// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._20ZZWzkSj8HnVPoZZO_CjY{width:100%;height:32px;border-bottom:1px solid rgba(153,168,198,0.25);display:flex;align-items:center;justify-content:space-between;padding:0 20px}.HxGs5i5ad0flo7e--ZWxf{display:flex;align-items:center}.HxGs5i5ad0flo7e--ZWxf .QhslCShEmhnqZhex4xVZc{font-size:12px;margin:0;font-weight:600;color:#99a8c6;margin-left:16px;text-decoration:none;cursor:pointer}.HxGs5i5ad0flo7e--ZWxf ._9yMJAybd0iUmuOAeFGpEH{height:20px}._2kzU-fEn-v8iEAQ58g2Lbv{cursor:pointer;display:flex;align-items:center;height:28px;background-color:#fff;padding:0 8px}._2kzU-fEn-v8iEAQ58g2Lbv:hover{background-color:#f7f7f7}._2kzU-fEn-v8iEAQ58g2Lbv ._2Hz_tYAv9ZHPZcD1YjJEVd{font-size:12px;color:#131a4f;margin-right:8px}._2kzU-fEn-v8iEAQ58g2Lbv img{height:16px;width:16px}._2EYFZoH4MPI2wJj5Z_-jCi{color:#ff6040}._3b105GqYHVjWKOVtQzxUrb{min-width:130px}._3b105GqYHVjWKOVtQzxUrb ._1Domaf8fMXTKuPYXQUbkf4{margin:0;list-style-type:none;padding:0}._3b105GqYHVjWKOVtQzxUrb ._1Domaf8fMXTKuPYXQUbkf4 a i{color:#3c4b64}._3b105GqYHVjWKOVtQzxUrb ._1Domaf8fMXTKuPYXQUbkf4 ._1XCL1F8x4bXvy-BjiIOx0c{display:flex;justify-content:space-between;color:#131a4f;font-weight:700;font-size:12px;padding:0 10px;cursor:pointer;text-decoration:none}._3b105GqYHVjWKOVtQzxUrb ._1Domaf8fMXTKuPYXQUbkf4 ._1XCL1F8x4bXvy-BjiIOx0c:hover{background-color:#f7f7f7}._3b105GqYHVjWKOVtQzxUrb ._1Domaf8fMXTKuPYXQUbkf4 ._1XCL1F8x4bXvy-BjiIOx0c i{font-size:16px;display:flex;align-items:center;margin-left:8px}._3b105GqYHVjWKOVtQzxUrb ._1Domaf8fMXTKuPYXQUbkf4 li:not(:last-child){border-bottom:1px solid #ecedf5}._2HsflxdWXe2EHS2iouBCag{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:6px;border:1px solid #ecedf5;box-shadow:0 2px 4px rgba(184,186,202,0.25);background:white;border-radius:8px}\n", ""]);
// Exports
exports.locals = {
	"primary-dark": "#e73b05",
	"primary": "#ff6040",
	"primary-light": "#ffe4df",
	"primary-extra-light": "#fff2f0",
	"secondary-dark": "#8292b1",
	"secondary": "#99a8c6",
	"secondary-light": "#d0dae9",
	"secondary-extra-light": "#eef4fc",
	"default-dark": "#898ca7",
	"default": "#b8baca",
	"default-light": "#ecedf5",
	"default-extra-light": "#f8f8f8",
	"warning-dark": "#d96800",
	"warning": "#fbab00",
	"warning-light": "#ffeba3",
	"warning-extra-light": "#fff5d1",
	"info-dark": "#0a82c6",
	"info": "#2eb6ea",
	"info-light": "#beebfc",
	"info-extra-light": "#dff5fe",
	"success-dark": "#069941",
	"success": "#3aaa35",
	"success-light": "#c6f1c3",
	"success-extra-light": "#e3f9e1",
	"danger-dark": "#cd0101",
	"danger": "#ff4141",
	"danger-light": "#ffcece",
	"danger-extra-light": "#ffe7e7",
	"text-primary": "#131a4f",
	"text-secondary": "#8292b1",
	"shadow-25": "rgba(184,186,202,0.25)",
	"shadow-50": "rgba(184,186,202,0.5)",
	"container": "_20ZZWzkSj8HnVPoZZO_CjY",
	"titleWrapper": "HxGs5i5ad0flo7e--ZWxf",
	"title": "QhslCShEmhnqZhex4xVZc",
	"logo": "_9yMJAybd0iUmuOAeFGpEH",
	"userWrapper": "_2kzU-fEn-v8iEAQ58g2Lbv",
	"username": "_2Hz_tYAv9ZHPZcD1YjJEVd",
	"logoutText": "_2EYFZoH4MPI2wJj5Z_-jCi",
	"popoverContent": "_3b105GqYHVjWKOVtQzxUrb",
	"popoverList": "_1Domaf8fMXTKuPYXQUbkf4",
	"popoverListElement": "_1XCL1F8x4bXvy-BjiIOx0c",
	"popover": "_2HsflxdWXe2EHS2iouBCag"
};
module.exports = exports;
